import axios from 'axios';
import api from '@/constants/api';
import { getUrl, Methods } from '.';

export interface ContactUsParams {
  name: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  position: string;
  countryCode: string;
  industry: string;
  consultingServices: string;
  howToKnowUs: string;
  advertisingCountries: string[];
}

export const contactUs = (data: ContactUsParams) => {
  return axios.request({
    method: Methods.POST,
    url: getUrl(api.contactUs),
    data,
  });
};
